var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 8.49935H3.25342C2.98008 8.49935 2.75342 8.27268 2.75342 7.99935V2.99935C2.75342 1.98602 3.57342 1.16602 4.58675 1.16602H8.00008C10.0201 1.16602 11.6668 2.81268 11.6668 4.83268C11.6668 6.85268 10.0201 8.49935 8.00008 8.49935ZM3.74675 7.49935H8.00008C9.47342 7.49935 10.6668 6.30602 10.6668 4.83268C10.6668 3.35935 9.47342 2.16602 8.00008 2.16602H4.58675C4.12675 2.16602 3.75342 2.53935 3.75342 2.99935V7.49935H3.74675Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58675 14.8333H4.58675C3.57342 14.8333 2.75342 14.0133 2.75342 13V8C2.75342 7.72667 2.98008 7.5 3.25342 7.5H9.58675C11.6068 7.5 13.2534 9.14667 13.2534 11.1667C13.2534 13.1867 11.6068 14.8333 9.58675 14.8333ZM3.74675 8.5V13C3.74675 13.46 4.12008 13.8333 4.58008 13.8333H9.58008C11.0534 13.8333 12.2468 12.64 12.2468 11.1667C12.2468 9.69333 11.0534 8.5 9.58008 8.5H3.74675Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextBold);
export default __webpack_public_path__ + "static/media/text-bold.6d3ec996.svg";
export { ForwardRef as ReactComponent };